import React from 'react'

const CancledCol = ({ cancled }) => {
    return (
        <p className='department_employe_count_mobile default_color'>{cancled.count}</p>
    )
}

export default CancledCol